"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _grey = _interopRequireDefault(require("../tokens/color/grey"));
var _white = _interopRequireDefault(require("../tokens/color/white"));
var _noop = _interopRequireDefault(require("lodash-es/noop"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var preloadImg = function preloadImg(src) {
  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.onload = function () {
      resolve();
    };
    img.src = src;
  });
};
var ZImage = function ZImage(props) {
  var _props$src = props.src,
    src = _props$src === void 0 ? "" : _props$src,
    _props$base = props.base64,
    base64 = _props$base === void 0 ? "" : _props$base,
    _props$ratio = props.ratio,
    ratio = _props$ratio === void 0 ? 0 : _props$ratio,
    _props$container = props.container,
    container = _props$container === void 0 ? null : _props$container,
    _props$alt = props.alt,
    alt = _props$alt === void 0 ? "image" : _props$alt,
    _props$fit = props.fit,
    fit = _props$fit === void 0 ? "cover" : _props$fit,
    _props$doPreload = props.doPreload,
    doPreload = _props$doPreload === void 0 ? false : _props$doPreload,
    _props$height = props.height,
    height = _props$height === void 0 ? "100%" : _props$height,
    _props$width = props.width,
    width = _props$width === void 0 ? "100%" : _props$width,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    _props$onClick = props.onClick,
    onClick = _props$onClick === void 0 ? _noop["default"] : _props$onClick,
    _props$srcSet = props.srcSet,
    srcSet = _props$srcSet === void 0 ? "" : _props$srcSet,
    _props$fallBack = props.fallBack,
    fallBack = _props$fallBack === void 0 ? "https://b.zmtcdn.com/images/placeholder_200.png?output-quality=70" : _props$fallBack,
    _props$isBackground = props.isBackground,
    isBackground = _props$isBackground === void 0 ? false : _props$isBackground,
    _props$bgGradient = props.bgGradient,
    bgGradient = _props$bgGradient === void 0 ? null : _props$bgGradient,
    _props$customZimageCo = props.customZimageComponent,
    customZimageComponent = _props$customZimageCo === void 0 ? null : _props$customZimageCo,
    _props$loadingCompone = props.loadingComponent,
    loadingComponent = _props$loadingCompone === void 0 ? null : _props$loadingCompone,
    _props$blurred = props.blurred,
    blurred = _props$blurred === void 0 ? "" : _props$blurred,
    _props$noTransform = props.noTransform,
    noTransform = _props$noTransform === void 0 ? false : _props$noTransform,
    _props$clickable = props.clickable,
    clickable = _props$clickable === void 0 ? false : _props$clickable;
  var ref = (0, _react.useRef)();
  var _useState = (0, _react.useState)(""),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    imgSrc = _useState2[0],
    setSrc = _useState2[1];
  // const [imgSrcSet, setImgSrcSet] = useState("");
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isImageLoaded = _useState4[0],
    setLoaded = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var handleOnImageLoad = function handleOnImageLoad() {
    if (blurred) {
      loadImage();
    }
    setLoaded(true);
  };
  var handleError = function handleError() {
    //currently not being used
    setError(true);
    //TODO::show an error image
    if (!!imgSrc && imgSrc !== fallBack) setSrc(fallBack);
  };

  // show shimmer again when src changes
  (0, _react.useEffect)(function () {
    if (isBackground && !!imgSrc) {
      var img = new Image();
      img.onload = handleOnImageLoad;
      img.onerror = handleError;
      img.src = imgSrc;
    }
    if (isImageLoaded) setLoaded(false);
  }, [imgSrc]);
  (0, _react.useEffect)(function () {
    var observer;
    var currentNode;
    if (!doPreload && "IntersectionObserver" in global) {
      var intersected = function intersected(_ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 1),
          entry = _ref2[0];
        var _entry$isIntersecting = entry.isIntersecting,
          isIntersecting = _entry$isIntersecting === void 0 ? false : _entry$isIntersecting;
        if (isIntersecting && imgSrc !== src) {
          setSrc(src);
          // setImgSrcSet(srcSet);
        }
      };
      var options = {
        root: container,
        threshold: ratio
      };
      observer = new IntersectionObserver(intersected, options);
      currentNode = ref.current;
      if (currentNode) observer.observe(currentNode);
    } else {
      setSrc(src);
    }
    return function () {
      typeof observer !== "undefined" && observer.unobserve && currentNode && observer.unobserve(currentNode);
    };
  }, [src]);
  var loadImage = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return preloadImg(imgSrc);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function loadImage() {
      return _ref3.apply(this, arguments);
    };
  }();
  var ZimageComponent = isBackground ? customZimageComponent || ZImage.BgDiv : ZImage.img;
  var LoaderComponent = base64 ? ZImage.base64 : loadingComponent || ZImage.Shimmer;
  return /*#__PURE__*/_react["default"].createElement(ZImage.Container, {
    ref: ref,
    height: height,
    width: width,
    className: className,
    onClick: onClick
  }, !blurred ? /*#__PURE__*/_react["default"].createElement(LoaderComponent, {
    isLoaded: !!imgSrc && isImageLoaded,
    src: base64
  }) : /*#__PURE__*/_react["default"].createElement(BlurredImg, {
    imgHeight: height,
    imgWidth: width,
    url: blurred,
    fit: fit
  }), /*#__PURE__*/_react["default"].createElement(ZimageComponent, {
    alt: alt,
    src: imgSrc,
    isLoaded: !!imgSrc && isImageLoaded,
    onLoad: handleOnImageLoad,
    loading: doPreload ? "auto" : "lazy",
    fit: fit,
    onError: handleError,
    noTransform: noTransform || !!blurred,
    blurred: !!blurred,
    clickable: !!clickable
    // srcSet={srcSet}
    // sizes={props.sizes}
  }));
};
ZImage.propTypes = {
  src: _propTypes["default"].string,
  base64: _propTypes["default"].string,
  ratio: _propTypes["default"].number,
  container: _propTypes["default"].node,
  alt: _propTypes["default"].string.isRequired,
  fit: _propTypes["default"].oneOf(["cover", "contain", "fill", "inherit", "initial", "none", "scale-down", "unset"]),
  doPreload: _propTypes["default"].bool,
  height: _propTypes["default"].string,
  width: _propTypes["default"].string,
  maxHeight: _propTypes["default"].string,
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  /** fallback image url, defaults to https://b.zmtcdn.com/images/placeholder_200.png?output-quality=70 */
  fallBack: _propTypes["default"].string,
  isBackground: _propTypes["default"].bool,
  bgGradient: _propTypes["default"].string,
  customZimageComponent: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  loadingComponent: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  noTransform: _propTypes["default"].bool,
  blurred: _propTypes["default"].string
};
var BlurredImg = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-s1isp7-0"
})(["position:absolute;top:0;background-image:url(", ");width:", ";height:", ";background-size:", ";filter:blur(10px);"], function (_ref4) {
  var url = _ref4.url;
  return url;
}, function (_ref5) {
  var imgWidth = _ref5.imgWidth;
  return imgWidth;
}, function (_ref6) {
  var imgHeight = _ref6.imgHeight;
  return imgHeight;
}, function (props) {
  return props.fit === "none" ? "".concat(props.imgWidth, " ").concat(props.imgHeight || "auto") : props.fit;
});
ZImage.Container = _styledComponents["default"].div.withConfig({
  componentId: "sc-s1isp7-1"
})(["position:relative;max-width:100%;width:", ";height:", ";overflow:hidden;"], function (props) {
  return props.width;
}, function (props) {
  return props.height ? props.height : "auto";
});
var shimmerAnimation = /*#__PURE__*/(0, _styledComponents.keyframes)(["0%{background-position:-80vw 0;}100%{background-position:80vw 0;}"]);
ZImage.base64 = _styledComponents["default"].img.withConfig({
  componentId: "sc-s1isp7-2"
})(["position:absolute;top:0;left:0;width:100%;height:100%;opacity:", ";will-change:transform,opacity;border-radius:inherit;transition:opacity 0.25s ease-in;"], function (props) {
  return props.isLoaded ? 0 : 1;
});
ZImage.Shimmer = _styledComponents["default"].div.withConfig({
  componentId: "sc-s1isp7-3"
})(["width:100%;position:absolute;top:0;left:0;height:100%;background:", ";background-image:linear-gradient( to right,", " 0%,", " 10%,", " 40%,", " 100% );background-repeat:no-repeat;opacity:", ";transition:opacity 0.25s ease-out;will-change:opacity;border-radius:inherit;animation:", " 1.5s infinite linear forwards;"], _grey["default"].z95, _grey["default"].z95, _white["default"], _grey["default"].z95, _grey["default"].z95, function (props) {
  return props.isLoaded ? 0 : 1;
}, shimmerAnimation);
ZImage.BgDiv = _styledComponents["default"].div.withConfig({
  componentId: "sc-s1isp7-4"
})(["width:100%;height:100%;transform:", ";opacity:", ";will-change:transform,opacity;border-radius:inherit;transition:opacity 0.25s ease,transform 0.25s ease;background-size:", ";background-position:center center;background-repeat:no-repeat;background-image:", ";"], function (props) {
  return props.isLoaded || props.noTransform ? "none" : "scale(0.9)";
}, function (props) {
  return props.isLoaded ? 1 : 0;
}, function (props) {
  return props.fit || "cover";
}, function (props) {
  return props.url && (props.bgGradient ? "".concat(props.bgGradient, ",url(").concat(props.url, ")") : "url(".concat(props.url, ")"));
});
var getTransition = function getTransition(_ref7) {
  var clickable = _ref7.clickable,
    blurred = _ref7.blurred;
  if (clickable && blurred) {
    return "transform 0.4s ease-in-out, opacity 1.63s ease, filter 0.4s ease";
  }
  if (clickable) {
    return "transform 0.4s ease-in-out, filter 0.4s ease, opacity 0.25s ease";
  }
  if (blurred) {
    return "opacity 1.63s ease, transform 0.25s ease";
  }
  return "opacity 0.25s ease, transform 0.25s ease";
};
ZImage.img = _styledComponents["default"].img.withConfig({
  componentId: "sc-s1isp7-5"
})(["width:100%;height:100%;object-fit:", ";transform:", ";opacity:", ";will-change:transform,opacity;border-radius:inherit;filter:", ";transition:", ";:hover{transform:", ";filter:", ";}img:not([src]):not([srcset]){visibility:hidden;}@-moz-document url-prefix(){img:-moz-loading{visibility:hidden;}}"], function (props) {
  return props.fit;
}, function (props) {
  return props.isLoaded || props.noTransform ? "none" : "scale(0.9)";
}, function (props) {
  return props.isLoaded ? 1 : 0;
}, function (props) {
  return props.clickable ? "brightness(0.95)" : "unset";
}, getTransition, function (props) {
  return props.clickable ? "scale(1.05)" : "";
}, function (props) {
  return props.clickable ? "brightness(1.05)" : "";
});
var _default = exports["default"] = ZImage;